/* lua.js generated code 0.3.0 */

var SettingButton = xClass("SettingButton", HomeSceneButton)

var SettingBtnConst = {
    Name : "settin",
    Res : "cocos/homeScene_set_btn.csb"
}

SettingButton.prototype.ctor = function () {
    HomeSceneButton.prototype.ctor.call(this, SettingBtnConst.Name, SettingBtnConst.Res, true, true, PromptTypeDef.justDot, false);
}

SettingButton.prototype.init = function () {
    var self = this
    HomeSceneButton.prototype.init.call(self)
    self.text.setVisible(false)
    self.updatePrompt()
}

SettingButton.prototype.onCick = function () {
    var self = this
    self.onOpenSetting()
}

SettingButton.prototype.onOpenSetting = function () {
    var self = this
    let showGuide = false
    if (UserLocalSettings.getSetting("GameEffectLevelGuide") != 1){
        UserLocalSettings.setSetting("GameEffectLevelGuide", 1)
        showGuide = true
    }
    require("clover/panel/SettingPanel").show(showGuide)
    self.updatePrompt()
}

SettingButton.prototype.test = function () {
    LocalNotificationManager.getInstance().setTestNotification()
    LocalNotificationManager.getInstance().pushAllNotifications()
}

// 未展示动画效果引导需要显示红点
SettingButton.prototype.updatePrompt = function(){
    var self = this
    var f = true
    if (UserLocalSettings.getSetting("GameEffectLevelGuide") == 1){
        f = false
    }else{
        let device = getDeviceInfo()
        if (parseInt(device.quality) > 24){
            f = false
        }
    }
    self.prompt.setVisible(f)
    return f
}

module.exports = SettingButton
